/*
 * @Author: gongyu
 * @Description: 
 * @Date: 2021-06-22 14:48:09
 * @LastEditors: mengli
 * @LastEditTime: 2023-06-07 09:03:47
 */
export function GoodAdaptor(list: any): Good.GoodInfo {
  return list.map((v: any) => {
    return {
      goodsId: v.goods_id,
      goodsName: v.goods_name,
      marketPrice: v.market_price,
      shopPrice: v.shop_price ,
      memberPrice:v.member_price || 0,
      goodsRemark: v.goods_remark,
      originalImage: v.original_image,
      goodsLabel: v.goods_label,
      goodsContent: v.goods_content,
      goodsSn: v.goods_sn,
      selfshop: v.selfshop,
      overSeal:v.overSeal,
      dutyfree:v.dutyfree,
      flashSale:v.flashSale,
      coupon:v.coupon,
      jumpUrl:v.jump_url,
      goodsTags:v.goodsTags,
      goods_offline:v.goods_offline,
      rank_title: v.rank_title,
      goods_marketing_title: v.goods_marketing_title,
    }
  })
} 